<template>
  <div>{{ version }}</div>
</template>

<script>
import VersionService from "../services/VersionService";

export default {
  name: "Version",
  versionService: null,
  data() {
    return {
      version: ""
    };
  },
  created() {
    this.versionService = new VersionService();
  },
  mounted() {
    this.versionService.getVersionInfo().then(response => {
      this.version = response.data;
    });
  }
};
</script>
